/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
    });
    
    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      if(document.querySelector('#PopupModal-quickshop')){
        document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
      }
      if(qtyInput) qtyInput.value = 1;
      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    this.currentVariantMetafields = null;
  }

  connectedCallback() {
    // Element Connected callback
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    this.setCurrentVariantMetafields();
    this.setProductOptionSpecifications();
    this.setUpSuperSubscriptionAppWidget();

    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  setUpSuperSubscriptionAppWidget() {
    const superSimpleSubsWrapperEmbed = document.getElementById("super-simple-subs-wrapper-embed");

    if (!superSimpleSubsWrapperEmbed || !this.currentVariant) return;

    try {
      const {id: currentVariantId, price: currentVariantPrice} = this.currentVariant;

      // Function to update visibility of purchase option details
      const updateVisibility = (selectElement) => {
        let selectedValue = selectElement?.value;
        document.querySelectorAll(".purchase-option-details").forEach((detail) => {
          const id = `${detail.getAttribute("sss-selling-plan-id")}-${detail.getAttribute("product-variant-id")}`;
          detail.classList.toggle("hidden", id !== selectedValue);
        });
      };

      superSimpleSubsWrapperEmbed.querySelectorAll(".subscription-plan-wrapper.recurring").forEach((wrapper) => {
        const productVariantId = parseInt(wrapper.getAttribute("product-variant-id"));
        const isMatchingVariant = productVariantId === currentVariantId;

        wrapper.classList.toggle("hidden", !isMatchingVariant);

        if (isMatchingVariant) {
          const input = wrapper.querySelector("input[name='selling_plan_group']");
          let selectElement = wrapper.querySelector(".sss-selling-plan-select");

          if (input) {
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }

          if (selectElement) {
            // Initial visibility update
            selectElement.dispatchEvent(new Event("change", { bubbles: true }));
            updateVisibility(selectElement);

            // Event listener for dropdown change
            const handleSelectChange = (event) => updateVisibility(event.currentTarget);
            const handleInputChange = () => updateVisibility(selectElement);

            selectElement.addEventListener("change", handleSelectChange);
            input?.addEventListener("change", handleInputChange);

            // Cleanup event listeners to prevent memory leaks
            window.addEventListener("beforeunload", () => {
              selectElement.removeEventListener("change", handleSelectChange);
              input?.removeEventListener("change", handleInputChange);
            });
          }
        }
      });

      // Update price for one-time purchase options
      superSimpleSubsWrapperEmbed.querySelectorAll(".subscription-plan-wrapper.one-time .selling-plan-price").forEach((priceElement) => {
        if (priceElement) {
          priceElement.innerHTML = Utility.formatMoney(currentVariantPrice, window.globalVariables.money_format);
        }
      });
    } catch (error) {
      console.error("An unexpected error occurred during the super subscription widget update process.", error);
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * Custom logic for updating package size option specifications based on a selected size option.
   */
  setProductOptionSpecifications() {
    try {
      /*const productId = window.globalVariables.product.id;
      let productOptions = this.form.querySelector(`#product-${productId}-options`);
      productOptions = productOptions ? JSON.parse(productOptions.textContent) : {}
      let packageSizeOptionPosition = null;
      let sizeOptionPosition = null;
      let variantWhereColumn = null;
      productOptions.forEach(productOption => {
        const optionHandle = productOption.name.toLowerCase().replace(/\s+/g, '-');
        if (optionHandle === 'size') {
          sizeOptionPosition = productOption.position;
          variantWhereColumn = `option${productOption.position}`;
        }
        if (optionHandle === 'package-size') {
          packageSizeOptionPosition = productOption.position;
          // variantWhereColumn = `option${productOption.position}`;
        }
      });
      const selectedOptions = this._getOptionsFromRadio();
      if (sizeOptionPosition !== null && variantWhereColumn !== null && packageSizeOptionPosition != null && selectedOptions.length && selectedOptions.length > 1) {
        let variants = this._getVariantData();
        const matchingVariants = variants.filter((variant) => variant[variantWhereColumn] === selectedOptions[sizeOptionPosition - 1]);

        if (matchingVariants.length) {
          matchingVariants.forEach(matchingVariant => {
            const packageSizeSpecificationElement = this.form.querySelector(
              `#package-size-${matchingVariant[`option${packageSizeOptionPosition}`]}-specification`
            );

            const metafieldsElement = this.form.querySelector(`#variant-metafields-${matchingVariant.id}`);
            let metafields = metafieldsElement ? JSON.parse(metafieldsElement.textContent) : {};

            if (packageSizeSpecificationElement && metafields && metafields.waist_min && metafields.waist_max) {
              packageSizeSpecificationElement.textContent = `${metafields.case_count}/${matchingVariant[`option${packageSizeOptionPosition}`]}`;
            }
          })
        }
      }*/

      const productId = window.globalVariables.product.id;

      // Retrieve product options
      const productOptionsElement = this.form.querySelector(`#product-${productId}-options`);
      const productOptions = productOptionsElement ? JSON.parse(productOptionsElement.textContent) : [];

      let sizeOptionPosition = null;
      let packageSizeOptionPosition = null;
      let variantWhereColumn = null;

      // Extract size and package-size option positions
      productOptions.forEach(({ name, position }) => {
        const optionHandle = name.toLowerCase().replace(/\s+/g, '-');
        if (optionHandle === 'size') {
          sizeOptionPosition = position;
          variantWhereColumn = `option${position}`;
        } else if (optionHandle === 'package-size') {
          packageSizeOptionPosition = position;
        }
      });

      const selectedOptions = this._getOptionsFromRadio();
      if (
        sizeOptionPosition !== null &&
        variantWhereColumn &&
        packageSizeOptionPosition !== null &&
        selectedOptions.length > 1
      ) {
        const variants = this._getVariantData();

        // Filter matching variants by the selected size option
        const matchingVariants = variants.filter(
          (variant) => variant[variantWhereColumn] === selectedOptions[sizeOptionPosition - 1]
        );

        matchingVariants.forEach((variant) => {
          const packageSizeKey = `option${packageSizeOptionPosition}`;
          const packageSizeSpecificationElement = this.form.querySelector(
            `#package-size-${variant[packageSizeKey]}-specification`
          );

          const metafieldsElement = this.form.querySelector(`#variant-metafields-${variant.id}`);
          const metafields = metafieldsElement ? JSON.parse(metafieldsElement.textContent) : {};

          // Update package size specifications if necessary data exists
          const caseCount = parseInt(metafields.case_count || 0);
          if (packageSizeSpecificationElement && caseCount > 0) {
            packageSizeSpecificationElement.textContent = `${metafields.case_count}/${variant[packageSizeKey]}`;
          }
        });
      }
    } catch (error) {
      console.error('An unexpected error occurred during the product option specifications update process.', error)
    }
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  setCurrentVariantMetafields() {
    try {
      if (!this.currentVariant) {
        return;
      }
      const metafieldsElement = this.form.querySelector(`#variant-metafields-${this.currentVariant.id}`);
      this.currentVariantMetafields = metafieldsElement ? JSON.parse(metafieldsElement.textContent) : {};
    } catch (error) {
      console.error('An unexpected error occurred during the current variant metafields set process.', error)
    }
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.textContent = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if (this.currentVariantMetafields && this.currentVariantMetafields.case_count) {
      let pricePerPieceElement = container.querySelector('#price-per-piece');
      const caseCount = parseInt(this.currentVariantMetafields.case_count || 0);
      if (caseCount > 0 && currentVariant.price > 0) {
        // Create the element if it doesn't exist
        if (!pricePerPieceElement) {
          pricePerPieceElement = document.createElement('span');
          pricePerPieceElement.className = 'd-inline-block price_pc ms-2 pt-0';
          pricePerPieceElement.id = 'price-per-piece';
          container.querySelector('.price-wrapper')?.appendChild(pricePerPieceElement);
        }

        // Update the content
        const pricePerPieceText = Utility.formatMoney((currentVariant.price / caseCount), window.globalVariables.money_format)
        pricePerPieceElement.textContent = `${pricePerPieceText}/pc.`;
      } else if (pricePerPieceElement) {
        // Remove the element if conditions are not met
        pricePerPieceElement.remove();
      }
    }

    if(priceElement) priceElement.textContent = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);;
    if(comparePriceElement) {
      comparePriceElement.textContent = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      if(currentVariant.compare_at_price == null || currentVariant.compare_at_price <= 0 || currentVariant.compare_at_price == currentVariant.price){
        comparePriceElement.classList.add('d-none');
      }else{
        comparePriceElement.classList.remove('d-none');
      }
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 

    const featured_image = currentVariant.featured_image || null;
    if(featured_image != null){
      if(this.formType == 'grid'){
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = currentVariant.featured_image.src;
        featuredImage.srcset = currentVariant.featured_image.src;
      }else{
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        if(this.formType == 'quickshop'){
          imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${currentVariant.featured_media.id}"]`);
        }
        if(!imageSlide) return;
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(this.formType == 'quickshop' && quickShopSlider){
          quickShopSlider.slideTo(slideIndex, 0, false);
        }else if(productSlider){
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);